import React, { useState, useEffect } from 'react';
import { Select, Button } from 'antd';
import './SearchHeader.css';
import { UnorderedListOutlined, AppstoreOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import attractionStore from '../../../store/AttractionStore';
import languageStore from '../../../store/languageStore';

const { Option } = Select;

const SearchHeader = ({ title, onSearch, onLocationChange, onSortChange, onCalculatorVisibleChange, isCalculatorVisible, viewType, changeViewType }) => {
  function capitalizeFirstLetters(str) {
    return str.split(' ').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }

  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedSort, setSelectedSort] = useState("");

  useEffect(() => {
    setSelectedLocation(capitalizeFirstLetters(t("ATTRACTIONS_filter_areas_all")));
    setSelectedSort(t("ATTRACTIONS_order_by_free"));
  }, [languageStore.selectedLanguage]);

  const handleLocationChange = (value) => {
    setSelectedLocation(value);
    onLocationChange(value);
  };

  const handleSortChange = (value) => {
    setSelectedSort(value);
    onSortChange(value);
  };

  return (
    <div className='attraction-header-container'> 
      <div className="search-header">
        <div className='search-header-title-container'>
          <h3>{title}</h3>
          <div className='grid-list-map-container'>
            <AppstoreOutlined onClick={() => changeViewType('grid')} style={{color: viewType === "grid" ? 'orange' : 'gray'}} />
            <UnorderedListOutlined onClick={() => changeViewType('list')} style={{color: viewType === "list" ? 'orange' : 'gray'}} />
            <EnvironmentOutlined onClick={() => changeViewType('map')} style={{color: viewType === "map" ? 'orange' : 'gray'}} />  
          </div>
        </div>

        <div className='search-header-filter-container'>
          <Select value={selectedLocation} className="select-input" onChange={handleLocationChange}>
            <Option value={capitalizeFirstLetters(t("ATTRACTIONS_filter_areas_all"))}>{capitalizeFirstLetters(t("ATTRACTIONS_filter_areas_all"))}</Option>
            {attractionStore.praguAreas.map((item) => {
              return (
                <Option value={capitalizeFirstLetters(item?.content[languageStore?.selectedLanguage]?.title)}>
                  {capitalizeFirstLetters(item?.content[languageStore?.selectedLanguage]?.title)}
                </Option>
              )
            })}
          </Select>
          
          <Select value={selectedSort} className="select-input" onChange={handleSortChange}>
            <Option value={t("ATTRACTIONS_order_by_az")}>{t("ATTRACTIONS_order_by_az")}</Option>
            <Option value={t("ATTRACTIONS_order_by_popularity")}>{t("ATTRACTIONS_order_by_popularity")}</Option>
            <Option value={t("ATTRACTIONS_order_by_discounts")}>{t("ATTRACTIONS_order_by_discounts")}</Option>
            <Option value={t("ATTRACTIONS_order_by_free")}>{t("ATTRACTIONS_order_by_free")}</Option>
          </Select>
        </div>
      </div>
      
      <div className='calculator-visible-container'>
        <Button onClick={() => onCalculatorVisibleChange()} className="show-calculator-button">
          {isCalculatorVisible ? t("CALCULATOR_hide_calculator") : t("CALCULATOR_show_calculator")}
        </Button>
      </div>
    </div>
  );
};

export default SearchHeader;
